// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".table-container[data-v-1b5f2134]{margin:0 auto;width:350px}.report-table[data-v-1b5f2134]{font-size:15px;line-height:20px;margin:0 0 20px;width:100%}.report-table tbody[data-v-1b5f2134]:not(:first-child){border-bottom:35px solid transparent}.report-table tbody[data-v-1b5f2134]:last-child{border-bottom:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
